import { Courier } from 'icons';
import { FormattedMessage } from 'localization';

import { EnumDeskRoutes, EnumShippingSettingRoutes } from '../../../constants';
import { SettingsSidebarMenuItem } from '../AdminSettingsSidebar';

const shippingSection: SettingsSidebarMenuItem = {
  icon: <Courier width={24} height={24} />,
  data: [
    {
      value: `/${EnumDeskRoutes.settings}/${EnumShippingSettingRoutes.shippingConfiguration}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="desk-app.configuration" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumShippingSettingRoutes.shippingRules}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="settings.rules.tabs.smart" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumShippingSettingRoutes.shippingCouriers}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="desk.couriers" />
        </div>
      ),
    },
  ],
  translationKey: 'dashboard.shipping',
};

export { shippingSection };
